import React from "react";
import { t, Trans } from "@lingui/macro";
import { DProductsFilters } from "./filters";
import { DEdmProductInfoActions } from "./actions";
import { PopupAdd } from "./popupContents/popupAdd";
import { TableBody, TableHeader } from "./tableData";
import { PopupEdit } from "./popupContents/popupEdit";
import { PopupDetails } from "./popupContents/popupDetails";
import { DashboardContentPage } from "../DashboardContentTable";
import { InputSearch } from "components/UI/InputSearch/InputSearch";
import { FiltersDashboard } from "../DashboardContentTable/FiltersDashboard";
import { DataTableDashboard } from "../DashboardContentTable/DataTableDashboard";
import { PopupPanelDashboard } from "../DashboardContentTable/PopupPanelDashboard";
import { typePaginationDashboardObject } from "../DashboardContentTable/PaginationDashboard/PaginationDashboard";
import {
  typeDataProductInfoRowActions,
  typeDataProductInfoBulkActions,
} from "./index";

export type typeViewDataProductInfo = {
  variant?: string;
  setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>;

  onClickAdd: () => void;

  openFilterBar: boolean;
  setOpenFilterBar: React.Dispatch<React.SetStateAction<boolean>>;

  openPopupDetails: boolean;
  setOpenPopupDetails: React.Dispatch<React.SetStateAction<boolean>>;

  openPopupAdd: boolean;
  setOpenPopupAdd: React.Dispatch<React.SetStateAction<boolean>>;

  openPopupEdit: boolean;
  setOpenPopupEdit: React.Dispatch<React.SetStateAction<boolean>>;

  searchValue: string;
  onClearSearch: () => void;
  onEnterSearch: () => void;
  onChangeSearchValue: (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLTextAreaElement>
  ) => void;

  isActiveFilters: boolean;
  setIsActiveFilters: React.Dispatch<React.SetStateAction<boolean>>;

  pagination: typePaginationDashboardObject;
  rowsActions: typeDataProductInfoRowActions;
  bulkActions: typeDataProductInfoBulkActions;
};

export const ViewDataEdmProductInfo: React.FC<typeViewDataProductInfo> = ({
  variant,
  setSidebarOpen,

  onClickAdd,

  openFilterBar,
  setOpenFilterBar,

  openPopupDetails,
  setOpenPopupDetails,

  openPopupAdd,
  setOpenPopupAdd,

  openPopupEdit,
  setOpenPopupEdit,

  searchValue,
  onClearSearch,
  onEnterSearch,
  onChangeSearchValue,

  isActiveFilters,
  setIsActiveFilters,

  pagination,
  rowsActions,
  bulkActions,
}) => {
  return (
    <DashboardContentPage
      setSidebarOpen={setSidebarOpen}
      headerTitle={<Trans>Warehouse products</Trans>}
      actions={<DEdmProductInfoActions onClickAdd={onClickAdd} />}
    >
      {/* Filter bar */}
      <FiltersDashboard
        variant={variant}
        isActiveFilters={isActiveFilters}
        filters={{
          filtersForm: (
            <DProductsFilters
              setOpenFilterBar={setOpenFilterBar}
              setIsActiveFilters={setIsActiveFilters}
            />
          ),
          openFilterBar: openFilterBar,
          setOpenFilterBar: setOpenFilterBar,
        }}
        searchBar={
          <InputSearch
            id="productSearch"
            value={searchValue}
            name="productSearch"
            onClear={onClearSearch}
            onChange={onChangeSearchValue}
            onKeyEnterDown={onEnterSearch}
            placeholder={t`Search by product's name`}
          />
        }
      />

      {/* Table data */}
      <DataTableDashboard
        pagination={pagination}
        tableHeader={<TableHeader bulkOperations={bulkActions} />}
        tableBody={
          <TableBody
            variant={variant}
            rowsActions={rowsActions}
            setOpenPopupDetails={setOpenPopupDetails}
          />
        }
      />

      <PopupPanelDashboard
        variant={variant}
        openPopup={openPopupDetails}
        setOpenPopup={setOpenPopupDetails}
        title={<Trans>Product details</Trans>}
      >
        <PopupDetails setOpenPopup={setOpenPopupDetails} />
      </PopupPanelDashboard>

      <PopupPanelDashboard
        variant={variant}
        openPopup={openPopupAdd}
        setOpenPopup={setOpenPopupAdd}
        title={<Trans>Add Product</Trans>}
      >
        <PopupAdd setOpenPopup={setOpenPopupAdd} />
      </PopupPanelDashboard>

      <PopupPanelDashboard
        variant={variant}
        openPopup={openPopupEdit}
        setOpenPopup={setOpenPopupEdit}
        title={<Trans>Edit Product</Trans>}
      >
        <PopupEdit setEditPopup={setOpenPopupEdit} />
      </PopupPanelDashboard>
    </DashboardContentPage>
  );
};
